import React from 'react';
import { Brain, Heart, Wallet, Users, AlertTriangle, ShieldAlert, Smartphone, MonitorOff } from 'lucide-react';
export function GamblingSignsSection() {
  return <section id="gambling-signs" className="py-20 md:py-28 bg-white" data-id="element-353">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-354">
        {/* PART A: Signs */}
        <div className="mb-16" data-id="element-355">
          <div className="text-center mb-12" data-id="element-356">
            <h2 className="text-3xl md:text-5xl font-serif font-bold text-[#0A5E5C] mb-6" data-id="element-357">
              Якими можуть бути ознаки проблемної гри?
            </h2>
            <div className="h-1 w-24 bg-[#D4A843] mx-auto rounded-full" data-id="element-358" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-359">
            <div className="bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-360">
              <div className="flex items-center gap-3 mb-4" data-id="element-361">
                <div className="w-10 h-10 rounded-full bg-[#0A5E5C]/10 flex items-center justify-center" data-id="element-362">
                  <Brain className="w-5 h-5 text-[#0A5E5C]" data-id="element-363" />
                </div>
                <h3 className="font-serif font-bold text-xl text-[#0A5E5C]" data-id="element-364">
                  Поведінкові ознаки
                </h3>
              </div>
              <ul className="space-y-2 text-gray-700" data-id="element-365">
                <li className="flex items-start gap-2" data-id="element-366">
                  <span className="text-[#D4A843] mt-1" data-id="element-367">•</span>
                  <span data-id="element-368">постійні думки про азартні ігри</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-369">
                  <span className="text-[#D4A843] mt-1" data-id="element-370">•</span>
                  <span data-id="element-371">бажання збільшувати ставки</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-372">
                  <span className="text-[#D4A843] mt-1" data-id="element-373">•</span>
                  <span data-id="element-374">спроби відіграти програні кошти</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-375">
                  <span className="text-[#D4A843] mt-1" data-id="element-376">•</span>
                  <span data-id="element-377">труднощі з припиненням гри</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-378">
                  <span className="text-[#D4A843] mt-1" data-id="element-379">•</span>
                  <span data-id="element-380">приховування ігрової активності</span>
                </li>
              </ul>
            </div>

            <div className="bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-381">
              <div className="flex items-center gap-3 mb-4" data-id="element-382">
                <div className="w-10 h-10 rounded-full bg-[#0A5E5C]/10 flex items-center justify-center" data-id="element-383">
                  <Heart className="w-5 h-5 text-[#0A5E5C]" data-id="element-384" />
                </div>
                <h3 className="font-serif font-bold text-xl text-[#0A5E5C]" data-id="element-385">
                  Емоційні ознаки
                </h3>
              </div>
              <ul className="space-y-2 text-gray-700" data-id="element-386">
                <li className="flex items-start gap-2" data-id="element-387">
                  <span className="text-[#D4A843] mt-1" data-id="element-388">•</span>
                  <span data-id="element-389">відчуття провини після гри</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-390">
                  <span className="text-[#D4A843] mt-1" data-id="element-391">•</span>
                  <span data-id="element-392">
                    дратівливість або тривога, коли немає можливості грати
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-393">
                  <span className="text-[#D4A843] mt-1" data-id="element-394">•</span>
                  <span data-id="element-395">використання гри для втечі від стресу або проблем</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-396">
                  <span className="text-[#D4A843] mt-1" data-id="element-397">•</span>
                  <span data-id="element-398">відчуття втрати контролю</span>
                </li>
              </ul>
            </div>

            <div className="bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-399">
              <div className="flex items-center gap-3 mb-4" data-id="element-400">
                <div className="w-10 h-10 rounded-full bg-[#0A5E5C]/10 flex items-center justify-center" data-id="element-401">
                  <Wallet className="w-5 h-5 text-[#0A5E5C]" data-id="element-402" />
                </div>
                <h3 className="font-serif font-bold text-xl text-[#0A5E5C]" data-id="element-403">
                  Фінансові ознаки
                </h3>
              </div>
              <ul className="space-y-2 text-gray-700" data-id="element-404">
                <li className="flex items-start gap-2" data-id="element-405">
                  <span className="text-[#D4A843] mt-1" data-id="element-406">•</span>
                  <span data-id="element-407">витрати, що перевищують можливості</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-408">
                  <span className="text-[#D4A843] mt-1" data-id="element-409">•</span>
                  <span data-id="element-410">позики або кредити для гри</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-411">
                  <span className="text-[#D4A843] mt-1" data-id="element-412">•</span>
                  <span data-id="element-413">борги або фінансові труднощі</span>
                </li>
              </ul>
            </div>

            <div className="bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-414">
              <div className="flex items-center gap-3 mb-4" data-id="element-415">
                <div className="w-10 h-10 rounded-full bg-[#0A5E5C]/10 flex items-center justify-center" data-id="element-416">
                  <Users className="w-5 h-5 text-[#0A5E5C]" data-id="element-417" />
                </div>
                <h3 className="font-serif font-bold text-xl text-[#0A5E5C]" data-id="element-418">
                  Соціальні ознаки
                </h3>
              </div>
              <ul className="space-y-2 text-gray-700" data-id="element-419">
                <li className="flex items-start gap-2" data-id="element-420">
                  <span className="text-[#D4A843] mt-1" data-id="element-421">•</span>
                  <span data-id="element-422">конфлікти з родиною</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-423">
                  <span className="text-[#D4A843] mt-1" data-id="element-424">•</span>
                  <span data-id="element-425">проблеми на роботі</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-426">
                  <span className="text-[#D4A843] mt-1" data-id="element-427">•</span>
                  <span data-id="element-428">соціальна ізоляція</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* PART B: Where to start */}
        <div className="mb-16" data-id="element-429">
          <h3 className="text-2xl md:text-3xl font-serif font-bold text-[#0A5E5C] mb-6" data-id="element-430">
            З чого ж почати?
          </h3>
          <div className="space-y-6 text-lg text-gray-700 leading-relaxed" data-id="element-431">
            <p data-id="element-432">
              Якщо гра в азартні ігри дійсно впливає на Ваше життя і Ви готові
              це визнати, або хоча б допустити цю думку, це вже успішний
              початок. Адже визнання і усвідомлення потребує великої сили, і
              якщо у Вас є ця сила визнати існуючий стан справ у Вашому житті, у
              Вас точно є сила діяти, щоб допомогти собі. Дуже важливо дати
              цьому усвідомленню місце і не намагатися боротися з ним чи з
              собою. Спробуйте дослідити із цікавістю, коли і як Ви могли
              втратити контроль над собою і віддали його грі, за яких обставин
              це відбулося, що саме Ви відчували і що могло бути причиною такого
              рішення, чи було це усвідомлено, чи Ви не пам'ятаєте, як раптом
              зрозуміли, що не можете зупинитись і не знайшли сил в собі це
              визнати одразу.
            </p>
            <p data-id="element-433">
              Якщо у Вас є хтось дуже близький і безпечний для Вас, той, хто
              приймає Вас і не судить, Ви могли б поділитися всіма цими думками,
              спогадами і почуттями, які виникають у Вас при такому дослідженні.
              Добрий, приймаючий погляд близької, безпечної для Вас людини може
              дуже допомогти. Подумайте, можливо поряд є людина, якій би Ви
              могли відкритися і не бути самотнім у цьому дослідженні себе.
            </p>
          </div>
        </div>

        {/* PART C: What to do to help yourself */}
        <div className="mb-16" data-id="element-434">
          <h3 className="text-2xl md:text-3xl font-serif font-bold text-[#0A5E5C] mb-6" data-id="element-435">
            Що можна зробити, щоб собі допомогти?
          </h3>
          <p className="text-lg text-gray-700 leading-relaxed mb-8" data-id="element-436">
            Якщо Ви вирішили взяти під контроль гру в азартні ігри, і вважаєте,
            що Вам достатньо лише просто підвищити усвідомленість щодо процесу
            гри в азартні ігри, то Вам можуть допомогти такі прості, але дієві
            поради.
          </p>

          <div className="space-y-6 mb-8" data-id="element-437">
            <div className="flex gap-4" data-id="element-438">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#D4A843] text-white flex items-center justify-center font-bold" data-id="element-439">
                1
              </div>
              <p className="text-lg text-gray-700 pt-1" data-id="element-440">
                <span className="font-bold text-[#0A5E5C]" data-id="element-441">
                  Встановіть ліміти для себе.
                </span>{' '}
                Визначте суму, яку Ви можете дозволити собі витрачати на
                розваги, і не перевищуйте її.
              </p>
            </div>

            <div className="flex gap-4" data-id="element-442">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#D4A843] text-white flex items-center justify-center font-bold" data-id="element-443">
                2
              </div>
              <p className="text-lg text-gray-700 pt-1" data-id="element-444">
                <span className="font-bold text-[#0A5E5C]" data-id="element-445">
                  Контролюйте час гри.
                </span>{' '}
                Встановіть часові обмеження або використовуйте таймер.
              </p>
            </div>

            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 rounded-r-xl ml-12 my-6" data-id="element-446">
              <div className="flex items-start gap-4" data-id="element-447">
                <AlertTriangle className="w-6 h-6 text-yellow-600 flex-shrink-0 mt-1" data-id="element-448" />
                <p className="text-yellow-800 font-medium leading-relaxed" data-id="element-449">
                  Пам'ятайте: на легальних сайтах Вас не можуть допустити до гри
                  без того, щоб Ви самостійно встановили такі ліміти. Поставтесь
                  усвідомлено до встановлення таких лімітів.
                </p>
              </div>
            </div>

            <div className="flex gap-4" data-id="element-450">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#D4A843] text-white flex items-center justify-center font-bold" data-id="element-451">
                3
              </div>
              <p className="text-lg text-gray-700 pt-1" data-id="element-452">
                <span className="font-bold text-[#0A5E5C]" data-id="element-453">
                  Не намагайтеся відігратися.
                </span>{' '}
                Спроби повернути програні гроші часто призводять до ще більших
                втрат.
              </p>
            </div>

            <div className="flex gap-4" data-id="element-454">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#D4A843] text-white flex items-center justify-center font-bold" data-id="element-455">
                4
              </div>
              <p className="text-lg text-gray-700 pt-1" data-id="element-456">
                <span className="font-bold text-[#0A5E5C]" data-id="element-457">
                  Уникайте гри під впливом емоцій.
                </span>{' '}
                Стрес, алкоголь або сильні емоції можуть призводити до
                імпульсивних рішень.
              </p>
            </div>

            <div className="flex gap-4" data-id="element-458">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#D4A843] text-white flex items-center justify-center font-bold" data-id="element-459">
                5
              </div>
              <p className="text-lg text-gray-700 pt-1" data-id="element-460">
                <span className="font-bold text-[#0A5E5C]" data-id="element-461">
                  Робіть регулярні перерви.
                </span>{' '}
                Регулярні паузи допомагають зберігати контроль.
              </p>
            </div>
          </div>

          <p className="text-lg text-gray-700 leading-relaxed bg-gray-50 p-6 rounded-xl border border-gray-100" data-id="element-462">
            Під час таких пауз, спробуйте проаналізувати свою поведінку під час
            гри, загальний емоційний стан і емоційний стан безпосередньо під час
            гри. Задайте собі питання, чи дійсно азартна гра для Вас виключно
            розвага, яка дарує позитивні емоції без жодних негативних впливів на
            Ваш фінансовий стан, емоційний стан, на Ваші думки, настрій, Ваші
            стосунки з зовнішнім світом і оточуючими Вас людьми. Спробуйте
            робити такий аналіз на регулярній основі.
          </p>
        </div>

        {/* PART D: Serious steps */}
        <div data-id="element-463">
          <p className="text-lg text-gray-700 leading-relaxed font-medium mb-8" data-id="element-464">
            Якщо Ви усвідомили, що гра в азартні ігри негативно впливає на Ваше
            життя, настрій, фінанси, стосунки, думки і вирішили діяти, щоб це
            змінити, корисними для Вас можуть бути наступні кроки.
          </p>

          <div className="space-y-6" data-id="element-465">
            <div className="bg-[#0A5E5C] text-white p-8 rounded-2xl shadow-lg relative overflow-hidden" data-id="element-466">
              <ShieldAlert className="absolute -right-4 -bottom-4 w-32 h-32 text-white/10" data-id="element-467" />
              <div className="relative z-10" data-id="element-468">
                <h4 className="text-xl font-bold mb-4 flex items-center gap-3" data-id="element-469">
                  <span className="w-8 h-8 rounded-full bg-[#D4A843] text-white flex items-center justify-center text-sm" data-id="element-470">
                    1
                  </span>
                  Самообмеження
                </h4>
                <p className="text-lg mb-4 leading-relaxed" data-id="element-471">
                  Подати заяву про самообмеження через сайт Державного Агентства
                  «Плейсіті»{' '}
                  <a href="http://www.playcity.gov.ua" className="underline hover:text-[#D4A843] transition-colors" data-id="element-472">
                    www.playcity.gov.ua
                  </a>{' '}
                  в Розділі «Громадянам» є опція «Заява про обмеження», або
                  подати таку заяву можна на сайті будь-якого он-лайн
                  організатора азартних ігор.
                </p>
                <div className="bg-white/10 p-4 rounded-lg space-y-3 text-sm" data-id="element-473">
                  <p data-id="element-474">
                    За наслідками подання такої заяви Ваші дані будуть внесені в
                    Реєстр осіб, яким обмежено доступ до гральних закладів
                    та/або участь в азартних іграх (далі – Реєстр).
                  </p>
                  <p className="text-[#D4A843] font-medium" data-id="element-475">
                    Але при цьому Ви маєте усвідомлювати, що внесення Ваших
                    даних у Реєстр обмежить Ваш доступ до гри лише у легальних
                    організаторів азартних ігор.
                  </p>
                </div>
              </div>
            </div>

            <p className="text-center text-gray-600 italic my-6" data-id="element-476">
              Тому Ви можете скористатися додатковими інструментами для того,
              щоб допомогти собі і обмежити свідомо свій доступ до азартних
              ігор.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-477">
              <div className="bg-white border-2 border-gray-100 rounded-2xl p-6 hover:border-[#0A5E5C] transition-colors" data-id="element-478">
                <h4 className="text-lg font-bold text-[#0A5E5C] mb-3 flex items-center gap-3" data-id="element-479">
                  <span className="w-6 h-6 rounded-full bg-[#D4A843] text-white flex items-center justify-center text-xs" data-id="element-480">
                    2
                  </span>
                  <Smartphone className="w-5 h-5" data-id="element-481" />
                  BETBLOCKER
                </h4>
                <p className="text-gray-700 mb-4 text-sm leading-relaxed" data-id="element-482">
                  Скористатися безкоштовним інструментом блокування BETBLOCKER,
                  про який Ви можете дізнатися на сайті{' '}
                  <a href="https://betblocker.org" className="text-[#0A5E5C] underline hover:text-[#D4A843]" data-id="element-483">
                    https://betblocker.org
                  </a>{' '}
                  або скачати його у вигляді мобільного додатку.
                </p>
                <p className="text-gray-500 text-xs" data-id="element-484">
                  Цей інструмент можна встановити для різних видів девайсів і
                  операційних систем і він діє з території України, вся
                  інформація на сайті і в додатку є українською мовою.
                </p>
              </div>

              <div className="bg-white border-2 border-gray-100 rounded-2xl p-6 hover:border-[#0A5E5C] transition-colors" data-id="element-485">
                <h4 className="text-lg font-bold text-[#0A5E5C] mb-3 flex items-center gap-3" data-id="element-486">
                  <span className="w-6 h-6 rounded-full bg-[#D4A843] text-white flex items-center justify-center text-xs" data-id="element-487">
                    3
                  </span>
                  <MonitorOff className="w-5 h-5" data-id="element-488" />
                  Gamban
                </h4>
                <p className="text-gray-700 mb-4 text-sm leading-relaxed" data-id="element-489">
                  Скористатися ще одним інструментом блокування Gamban{' '}
                  <a href="https://gamban.com" className="text-[#0A5E5C] underline hover:text-[#D4A843]" data-id="element-490">
                    https://gamban.com
                  </a>
                </p>
                <p className="text-gray-500 text-xs" data-id="element-491">
                  Цей інструмент діє в Україні, але не має українськомовного
                  варіанту і він платний (є безкоштовна пробна версія).
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}